import { render, staticRenderFns } from "./cocal-ranking-detail.vue?vue&type=template&id=33b63560&"
import script from "./cocal-ranking-detail.vue?vue&type=script&lang=js&"
export * from "./cocal-ranking-detail.vue?vue&type=script&lang=js&"
import style0 from "./cocal-ranking-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports